/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessInvoiceTransactionRequest
 */
export interface ProcessInvoiceTransactionRequest {
    /**
     * When true, a failed invoice transaction is reset to pending and reprocessed using the current invoice amount.
     * @type {boolean}
     * @memberof ProcessInvoiceTransactionRequest
     */
    retryFailed?: boolean;
}

/**
 * Check if a given object implements the ProcessInvoiceTransactionRequest interface.
 */
// @ts-ignore
export function instanceOfProcessInvoiceTransactionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

// @ts-ignore
export function ProcessInvoiceTransactionRequestFromJSON(json: any): ProcessInvoiceTransactionRequest {
    return ProcessInvoiceTransactionRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ProcessInvoiceTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessInvoiceTransactionRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retryFailed': !exists(json, 'retry_failed') ? undefined : json['retry_failed'],
    };
}

// @ts-ignore
export function ProcessInvoiceTransactionRequestToJSON(value?: ProcessInvoiceTransactionRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retry_failed': value.retryFailed,
    };
}

